import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import i18n from './i18n'
import './assets/styles/global.css'
// 导入自定义的rem脚本，支持高分辨率屏幕
import './assets/js/rem.js'

// 配置Element UI
Vue.use(ElementUI, {
  size: 'medium',
  zIndex: 3000
})

Vue.config.productionTip = false

// 设置Element UI的语言
Vue.prototype.$ELEMENT = {
  size: 'medium'
}

// 创建Vue实例
new Vue({
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
